import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, FormField, Input, Modal, Pagination, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiExport, mdiImport, mdiReload } from '@mdi/js';
import Icon from '@mdi/react';
import { format, parse } from 'date-fns';
import DPModal from '../../../../components/DPModal';
import Favorites from '../../../../components/extras/Favorites';
import SelectPaging from '../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../commons/functions';


export const SystemLogsPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")
    const [logs, setLogs] = useState<any[]>([])
    const [users, setUsers] = useState<any[]>([])
    const [log, setLog] = useState<any>(null);

    const { navigate } = useRouter();
    const { parameters, menu, idAirport } = useGlobalState();

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");
    const filtered: any[] = logs.filter((item) => {
        const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.action.toString(), item.dateLog.toString(),
        ].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);
    useEffect(() => {

    }, []);

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const timer = setTimeout(() => {
            handleGetLogs();
        }, 500);
        return () => clearTimeout(timer);
    }, [idAirport]);
    const handleGetLogs = async () => { // Make the function async
        if (!parameters.date || parameters.date == "") return;
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/logs/list',
                },
                body: JSON.stringify({ orderBy: "dateLog", order: "DESC", date: parameters.date }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                setLogs(dataWeb.logs);
                setUsers(dataWeb.users);
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    };
    useEffect(() => {
        if (parameters.date && parameters.date != "") {
            handleGetLogs();
        }
    }, [parameters.date]);

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    {log && (
                        <Modal visible={true} onDismiss={() => setLog(null)} closeAriaLabel="Close modal" header="Detalle LOG"
                            size="large">
                            <pre style={{ maxHeight: "400px", overflowY: "auto" }}>
                                {JSON.stringify(log, null, 2)}
                            </pre>
                        </Modal>
                    )}
                    <Header variant="h1" actions={<Favorites />}>Registro de LOGS</Header>
                    <Table
                        pagination={

                            <SpaceBetween direction="horizontal" size="xs" alignItems="center">

                                {filtered.length > parameters.pageSize && (
                                    <Pagination
                                        currentPageIndex={currentPageIndex}
                                        pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                        onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                    />
                                )}

                                {filtered.length > parameters.pageSize && (

                                    <SelectPaging onSelect={(pageSize) => {
                                        setCurrentPageIndex(1);
                                        setParameters({ ...parameters, pageSize: pageSize });
                                    }} />
                                )}
                            </SpaceBetween>
                        }
                        stickyHeader
                        filter={
                            <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                <DPModal date={parameters.date}
                                    end={new Date()}
                                    onConfirm={(dateStr: string) => {
                                        setParameters({ ...parameters, date: dateStr });
                                    }} />
                                <Input value={filterValue} placeholder="Palabra clave" onChange={e => setFilterValue(e.detail.value)} />
                                <Button disabled={(!parameters.date || parameters.date == "")} variant="primary" onClick={() => {
                                    handleGetLogs();
                                }}><Icon path={mdiReload} size={1} /></Button>
                            </SpaceBetween>
                        }
                        variant='borderless'
                        columnDefinitions={[
                            {
                                id: 'timestamp', header: 'Hora', cell: item => format(parse(item?.dateLog.toString(), "dd-MM-yyyy HH:mm:ss", new Date()), "HH:mm:ss") || "", width: 100
                            },
                            {
                                id: 'idUser', header: 'ID Usuario', cell: item => item?.idUser == 0 ? <em>Sistema</em> : users.find(user => user.idUser === item?.idUser)?.userName || "Desconocido ID " + item?.idUser, width: 100
                            },
                            {
                                id: 'action', header: 'Mensaje', cell: item => item?.reason && item?.reason === "" ?
                                    item?.action || "" :
                                    <FormField label={item?.action || ""}>{item?.reason || ""}</FormField>
                            },
                            {
                                id: 'in', header: 'Data', cell: item =>
                                    <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                        {item.jsonInput && <Button fullWidth variant="normal" onClick={() => {
                                            setLog(item.jsonInput);
                                        }}><Icon path={mdiImport} size={1} /></Button>}

                                        {item.jsonOutput && <Button fullWidth variant="normal" onClick={() => {
                                            setLog(item.jsonOutput);
                                        }
                                        }><Icon path={mdiExport} size={1} /></Button>}
                                    </SpaceBetween>,
                                width: 200
                            },
                            /*{
                                id: 'in', header: 'IN', cell: item =>
                                <Link onClick={() => {
                                    setLog(item.jsonInput);

                                }}>{JSON.stringify(item?.jsonInput).substring(0, 25) || ""}</Link>, width: 600
                            },
                            {
                                id: 'out', header: 'OUT', cell: item => <Link onClick={() => {
                                    setLog(item.jsonOutput);

                                }}>{JSON.stringify(item?.jsonOutput).substring(0, 25) || ""}</Link>, width: 600
                            },*/

                        ]}
                        items={paginated}
                    />

                </SpaceBetween>
            }
        />
    )
};
